import { createGlobalStyle } from 'styled-components/macro';
import { theme } from 'styled-tools';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
  }

  #root {
    height: inherit;
  }

  body {
    a, a:not([href]) {
      cursor: pointer;
      color: ${theme('link.color')};
      text-decoration: none;

      &:hover {
        color: ${theme('colors.primary')};
        text-decoration: underline;
      }
    }
  }

  nav .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    margin-left: auto;
    margin-right: auto;
    padding-left: 0.9375rem;
    padding-right: 0.9375rem;
    width: 100%;
  }

  @media (min-width: 576px) {
    .container,
    .container-sm {
      max-width: 33.75rem;
    }
  }

  @media (min-width: 768px) {
    .container,
    .container-md,
    .container-sm {
      max-width: 45rem;
    }
  }

  @media (min-width: 992px) {
    .container,
    .container-lg,
    .container-md,
    .container-sm {
      max-width: 60rem;
    }
  }

  @media (min-width: 1200px) {
    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
      max-width: 71.25rem;
    }
  }
`;

export default GlobalStyle;
